import { createContext, useContext } from 'react';
import type { RegistryTransaction } from '../../api';
import type { DomainContacts, DomainDelegation, DomainRegistryState } from '../../api/areas/core';

/** Reads the domain page loads once and every part shares (null while loading or refused). */
export interface DomainPageData {
  txs: RegistryTransaction[] | null;
  registryState: DomainRegistryState | null;
  delegation: DomainDelegation | null;
  /** Why the delegation could not be read, and how to read it again (null unless it failed). */
  delegationFailed: { error: unknown; retry: () => void } | null;
  contacts: DomainContacts | null;
}

export const DomainPageContext = createContext<DomainPageData>({ txs: null, registryState: null, delegation: null, delegationFailed: null, contacts: null });

export const useDomainPage = (): DomainPageData => useContext(DomainPageContext);
